import React from "react"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { TargetPopularBrands } from "../../../services/statisticsAPI"
import { DataTableSortStatus } from "mantine-datatable"
import sortBy from "lodash/sortBy"
import { setPageTitle } from "../../../redux/store/themeConfigSlice"
import { Brand } from "../../../types/brandDatas"
import { useNavigate } from "react-router-dom"
import StickyDataTable from "../../../components/StickyDataTable"
import { getErrorStatus, getErrorResponse } from "../../../types/error"

const PopularBrands = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const PAGE_SIZES = [10, 20, 30, 50, 100, 500, 1000]
  const [totalPages, setTotalPages] = useState(0)
  const [pageSize, setPageSize] = useState(PAGE_SIZES[2])
  const [initialRecords, setInitialRecords] = useState(sortBy([] as Brand[], "id"))
  const [sortStatus, setSortStatus] = useState<DataTableSortStatus>({
    columnAccessor: "id",
    direction: "asc",
  })
  const [sortByColumn, setSortByColumn] = useState("")
  const [sortOrder, setSortOrder] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    dispatch(setPageTitle("Popular Brands"))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setLoading(true)
    setError(null)
    const loadBrands = async () => {
      try {
        const response = await TargetPopularBrands(page, pageSize, sortByColumn, sortOrder)
        setInitialRecords(response.brands)
        setTotalPages(response.totalPages)
        setLoading(false)
      } catch (error: unknown) {
        if (getErrorStatus(error) === 401) {
          navigate("/login")
        }
        setError(`Error fetching data, ${getErrorResponse(error) || "Unknown error"}`)
        setLoading(false)
      }
    }
    loadBrands()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, sortByColumn, sortOrder])

  useEffect(() => {
    setPage(1)
  }, [pageSize])

  useEffect(() => {
    setSortStatus({
      columnAccessor: sortByColumn || "id",
      direction: sortOrder ? "desc" : "asc",
    })
  }, [sortByColumn, sortOrder])

  const handleSorting = (columnAccessor: string) => {
    if (columnAccessor === sortByColumn) {
      setSortOrder((prevOrder) => !prevOrder)
    } else {
      setSortByColumn(columnAccessor)
      setSortOrder(true)
    }
  }

  return (
    <div className="panel">
      <div className="mb-4.5 flex md:items-center md:flex-row flex-col gap-5">
        {error && (
          <div className="bg-red-200 text-red-800 border border-red-600 p-2 rounded">{error}</div>
        )}
      </div>
      <div className="datatables">
        {loading ? (
          <div className="flex items-center justify-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-pink-600"></div>
          </div>
        ) : (
          <StickyDataTable
            highlightOnHover={true}
            className="whitespace-nowrap"
            records={initialRecords}
            columns={[
              {
                accessor: "id",
                title: "Id",
                sortable: true,
              },
              { accessor: "username", title: "Marka İsmi", sortable: true },
              { accessor: "from_hashtag_search", title: "", sortable: true },
              { accessor: "brand_hashtag_counter", title: "Marka Hashtag Sayısı", sortable: true },
              { accessor: "followers", title: "Takipçi", sortable: true },
              { accessor: "following", title: "Takip", sortable: true },
              { accessor: "post_number", title: "Gönderi Sayısı", sortable: true },
            ]}
            totalRecords={totalPages * pageSize}
            recordsPerPage={pageSize}
            page={page}
            onPageChange={(p) => setPage(p)}
            recordsPerPageOptions={PAGE_SIZES}
            onRecordsPerPageChange={setPageSize}
            sortStatus={sortStatus}
            onSortStatusChange={(e) => handleSorting(e.columnAccessor)}
            minHeight={200}
            paginationText={({ from, to, totalRecords }) =>
              `Showing  ${from} to ${to} of ${totalRecords} entries`
            }
          />
        )}
      </div>
    </div>
  )
}

export default PopularBrands
